export default __webpack_public_path__ + "static/media/petqrbg.c36b7312.png";